import { object } from '../../../schema';
import { denormalize } from 'normalizr';


export const getId = (_, props) => props.match.params.id;
export const selectHydrated = (state, id) => denormalize(id, object, state.entities);



// WEBPACK FOOTER //
// ./src/redux/modules/objects/selectors.js